module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!./Sankey.js"));
	}, "Sankey");
}